import { ApiResult, HttpClient } from "../http.js";
import {
  VerificationFieldType,
  VerificationTemplateCategory,
  VerificationTemplateDto,
} from "../types/verification-templates.js";

export interface VerificationValidationRulePayload {
  type: string;
  value?: string | null;
  message?: string | null;
}

export interface VerificationTemplateFieldPayload {
  id: string;
  label: string;
  type: VerificationFieldType;
  required: boolean;
  order: number;
  options?: string[] | null;
  validationRules?: VerificationValidationRulePayload[] | null;
  defaultValue?: string | null;
  placeholder?: string | null;
  helpText?: string | null;
  unit?: string | null;
  minValue?: number | null;
  maxValue?: number | null;
}

export interface VerificationTemplateSectionPayload {
  id: string;
  title: string;
  description?: string | null;
  order: number;
  fields?: VerificationTemplateFieldPayload[] | null;
}

export interface CreateVerificationTemplatePayload {
  name: string;
  description?: string | null;
  category: VerificationTemplateCategory;
  trade?: string | null;
  isActive: boolean;
  sections?: VerificationTemplateSectionPayload[] | null;
  id?: string;
}

export interface UpdateVerificationTemplatePayload {
  name: string;
  description?: string | null;
  category: VerificationTemplateCategory;
  trade?: string | null;
  isActive: boolean;
  sections?: VerificationTemplateSectionPayload[] | null;
}

export interface ListVerificationTemplatesQuery {
  category?: VerificationTemplateCategory;
  trade?: string;
  isActive?: boolean;
}

export class VerificationTemplatesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListVerificationTemplatesQuery = {}): Promise<ApiResult<VerificationTemplateDto[]>> {
    return this.http.get<VerificationTemplateDto[]>("/api/verification-templates", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<VerificationTemplateDto>> {
    return this.http.get<VerificationTemplateDto>(`/api/verification-templates/${encodeURIComponent(id)}`);
  }

  create(payload: CreateVerificationTemplatePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/verification-templates", { body: payload });
  }

  update(id: string, payload: UpdateVerificationTemplatePayload): Promise<ApiResult<VerificationTemplateDto>> {
    return this.http.put<VerificationTemplateDto>(`/api/verification-templates/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/verification-templates/${encodeURIComponent(id)}`);
  }

  setDefault(id: string): Promise<ApiResult<VerificationTemplateDto>> {
    return this.http.post<VerificationTemplateDto>(`/api/verification-templates/${encodeURIComponent(id)}/set-default`, {});
  }
}
